module.exports = __webpack_public_path__ + "img/album17_01.6e46f304.jpg";